function requiredString(value, label, minimum = 1, maximum = 512) {
  if (typeof value !== "string" || value.length < minimum || value.length > maximum) {
    throw new Error(`${label} is missing or invalid.`);
  }
  return value;
}

function boundedNumber(value, label, minimum, maximum) {
  const number = Number(value);
  if (!Number.isFinite(number) || number < minimum || number > maximum) {
    throw new Error(`${label} is outside the supported range.`);
  }
  return number;
}

export function parseProvisioningBundle(raw, expectedApiUrl = "https://api.talos.m2llp.in") {
  let candidate;
  try {
    candidate = JSON.parse(raw);
  } catch {
    throw new Error("The private bundle is not valid JSON. Copy it again from the original installer screen.");
  }
  if (!candidate || Array.isArray(candidate) || typeof candidate !== "object") {
    throw new Error("The private bundle has an invalid structure.");
  }

  const apiUrl = requiredString(candidate.api_url, "API address", 12, 200).replace(/\/$/, "");
  if (apiUrl !== expectedApiUrl.replace(/\/$/, "")) {
    throw new Error("This private bundle belongs to a different Talos API.");
  }

  const connectivityType = candidate.connectivity_type === undefined ? "wifi" : requiredString(candidate.connectivity_type, "Internet connection", 4, 8);
  if (!["wifi", "cellular"].includes(connectivityType)) throw new Error("Internet connection is missing or invalid.");

  return {
    device_id: requiredString(candidate.device_id, "Device ID", 6, 64),
    device_key: requiredString(candidate.device_key, "Device key", 32, 512),
    api_url: apiUrl,
    maximum_temperature_c: boundedNumber(candidate.maximum_temperature_c, "Maximum temperature", -55, 125),
    measurement_interval_seconds: boundedNumber(candidate.measurement_interval_seconds, "Measurement interval", 10, 3600),
    logging_interval_seconds: boundedNumber(candidate.logging_interval_seconds, "Logging interval", 60, 86400),
    heartbeat_interval_seconds: boundedNumber(candidate.heartbeat_interval_seconds, "Heartbeat interval", 15, 3600),
    connectivity_type: connectivityType,
    hardware_name: candidate.hardware_name === undefined || candidate.hardware_name === null ? null : requiredString(candidate.hardware_name, "Hardware name", 3, 64),
  };
}
